/* POVA catalogue — mobile one-product-per-screen DECK.
 *
 * On phones (<=600px) the catalogue is one product per screen. Native CSS
 * scroll-snap alone still lets a slow drag or trackpad rest between products
 * (the "free scroll" feel), so this takes over: one flick / arrow / swipe =
 * EXACTLY one frame, moved with a smooth scrollTo, and free scrolling is
 * prevented in between. It drives the flagship /pages/products canvas and every
 * collection catalogue (both carry body.products).
 *
 * Scope + safety:
 *   • only active at <=600px (desktop's scattered canvas is left untouched);
 *   • disabled for prefers-reduced-motion (native CSS snap remains the fallback);
 *   • never hijacks scrolling while the cart drawer or nav drawer is open, or
 *     when the gesture happens inside one of those overlays;
 *   • frames = the optional Catalogue hero, each product tile, then the footer.
 */
(function () {
  var body = document.body;
  if (!body || body.className.indexOf('products') === -1) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var docEl = document.documentElement;
  var mq = matchMedia('(max-width: 600px)');
  var lockUntil = 0, stops = [], ty = null, active = false;

  function overlayOpen() {
    if (body.classList.contains('nav-open')) return true;
    var cd = document.querySelector('[data-cart-drawer]');
    if (cd && cd.getAttribute('aria-hidden') === 'false') return true;
    return false;
  }
  function inOverlay(e) {
    return !!(e.target && e.target.closest && e.target.closest('.cx-drawer, .nav-drawer'));
  }
  function busy() { return Date.now() < lockUntil; }
  function top(el) { return Math.round(el.getBoundingClientRect().top + window.pageYOffset); }
  function frames() {
    var els = [];
    var hero = document.querySelector('.cat-hero'); if (hero) els.push(hero);
    [].slice.call(document.querySelectorAll('.cat .cat-item')).forEach(function (i) { els.push(i); });
    var f = document.querySelector('.footer') || document.querySelector('footer'); if (f) els.push(f);
    return els;
  }
  function build() {
    var max = Math.max(0, docEl.scrollHeight - window.innerHeight);
    stops = frames().map(function (el) { return Math.min(top(el), max); })
      .filter(function (v, i, a) { return i === 0 || Math.abs(v - a[i - 1]) > 8; });
  }
  function nearest() {
    var y = window.pageYOffset, best = 0, bd = 1e9;
    stops.forEach(function (s, i) { var d = Math.abs(s - y); if (d < bd) { bd = d; best = i; } });
    return best;
  }
  function go(i) {
    i = Math.max(0, Math.min(stops.length - 1, i));
    window.scrollTo({ top: stops[i], behavior: 'smooth' });
  }
  function setActive(on) {
    active = on;
    /* When the deck drives scrolling, switch native CSS snap off so the two
       never fight; restore it when we hand back to desktop / a resize. */
    try { docEl.style.scrollSnapType = on ? 'none' : ''; } catch (e) {}
    if (on) build();
  }

  setActive(mq.matches);
  if (mq.addEventListener) mq.addEventListener('change', function (e) { setActive(e.matches); });
  else if (mq.addListener) mq.addListener(function (e) { setActive(e.matches); });

  window.addEventListener('wheel', function (e) {
    if (!active || overlayOpen() || inOverlay(e)) return;
    e.preventDefault();
    if (busy() || Math.abs(e.deltaY) < 6) return;
    lockUntil = Date.now() + 560; build();
    go(nearest() + (e.deltaY > 0 ? 1 : -1));
  }, { passive: false });

  window.addEventListener('keydown', function (e) {
    if (!active || overlayOpen()) return;
    if (['ArrowDown', 'PageDown', 'Spacebar', ' '].indexOf(e.key) >= 0) { e.preventDefault(); build(); go(nearest() + 1); }
    else if (['ArrowUp', 'PageUp'].indexOf(e.key) >= 0) { e.preventDefault(); build(); go(nearest() - 1); }
    else if (e.key === 'Home') { e.preventDefault(); build(); go(0); }
    else if (e.key === 'End') { e.preventDefault(); build(); go(stops.length - 1); }
  });

  window.addEventListener('touchstart', function (e) { ty = e.touches[0].clientY; }, { passive: true });
  window.addEventListener('touchmove', function (e) {
    if (!active || overlayOpen() || inOverlay(e)) return;
    e.preventDefault();
  }, { passive: false });
  window.addEventListener('touchend', function (e) {
    if (!active || overlayOpen() || inOverlay(e) || ty === null || busy()) return;
    var dy = ty - e.changedTouches[0].clientY; ty = null;
    if (Math.abs(dy) > 28) { lockUntil = Date.now() + 560; build(); go(nearest() + (dy > 0 ? 1 : -1)); }
  }, { passive: true });

  window.addEventListener('resize', function () { if (active) build(); });
  window.addEventListener('load', function () { if (active) build(); });
})();
